(function(){
    // Get all the Person containers
    let persons = document.querySelectorAll('.about-community__person-container');
    let modals = document.querySelectorAll('.about-community__person-detail-container');
    let el_to_fade = document.querySelectorAll('.about-community__elements__fade');
    let opening = false;

    function close_modals() {
        // Restore the opacity of all user blocks.
        // Hide all modal containers.
        if (opening) {
            opening = false;
            return;
        }
        for (let i = 0; i < el_to_fade.length; i++) {
            el_to_fade[i].style['opacity'] = '1';
        }
        for (let i = 0; i < modals.length; i++) {
            modals[i].style['display'] = 'none';
        }
    }

    function fade_all_but(idx) {
        for (let i = 0; i < el_to_fade.length; i++) {
            let id_parts = el_to_fade[i].id.split('_');
            if (id_parts.length > 1 && id_parts[1] != idx) {
                el_to_fade[i].style['opacity'] = '0.3';
            }
        }
    }

    function prevent_default_click(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    function block_clicked(e) {
        // Get the number of the block
        let idx = e.currentTarget.id.split('_')[1];
        let el = e.currentTarget;
        let window_width = window.innerWidth;
        let positioning = el.querySelector('.about-community__person-detail-positioning');
        let pos_x = positioning.offsetLeft;
        let pos_y = positioning.offsetTop;
        let modal = el.querySelector('.about-community__person-detail-container');

        if (modal.style['display'] == 'block') {
            close_modals();
            return;
        }

        close_modals();
        opening = true;
        // If mobile:
        //      Get the absolute position of 'about-community__person-detail-positioning'
        //      Get 'about-community__link-item-label' for modal.
        //      Absolute position modal to the top to the y position of the positioning element.
        //      Position the modal to be the width minus the margin.
        // Else desktop:
        //      Get the absolute position of 'about-community__person-detail-positioning'
        //      Get 'about-community__link-item-label' for modal.
        //      Test if the active block is the farthest to the right
        //      If to the right, align to the right edge of the positioner else the left
        modal.style['display'] = 'block';
        modal.style['top'] = (pos_y - 1) + "px";
        fade_all_but(idx);
        if (window_width < 1030) {
            modal.style['left'] = '0rem';
            modal.style['right'] = '0rem';
            modal.style['width'] = 'auto';
        }
        else {
            let is_3rd = false;
            if ((idx + 1) % 3 == 0) is_3rd = true;
            modal.style['width'] = "33.5625rem";
            if (is_3rd) {
                modal.style['right'] = '0rem';
            }
            else {
                modal.style['left'] = pos_x + "px";
            }
        }
    }

    // Set event handlers
    for (let i = 0; i < persons.length; i++) {
        persons[i].addEventListener('click', block_clicked);
    }
    /*
    for (let i = 0; i < modals.length; i++) {
        modals[i].addEventListener('click', prevent_default_click);
    }
    */
    document.addEventListener('click', close_modals);
})();
